<template>
  <div>
    <div class="cover-wrap">
      <ImageClip
        class="cover f-left"
        :src="course.cover_img"
        :width="420"
        :height="279"
        :radius="5"
      ></ImageClip>
      <div class="right f-left">
        <div class="title">{{ course.title }}</div>
        <div class="period">
          <template v-if="course.start_play_date">
            <span>
              {{ course.start_play_date | tsFormat("yyyy/MM/dd") }}-{{
                course.end_play_date | tsFormat("yyyy/MM/dd")
              }}
            </span>
            <span class="ver-line"></span>
          </template>
          <span>共{{ course.total_periods }}课时</span>
        </div>
        <CourseShowValid :course="course"></CourseShowValid>
        <div class="apply" v-if="course.course_type == 7">
          <div class="right">
            <div class="item">
              <span class="label">报名截止：</span>
              <span>{{ course.enter_end_date_str }}</span>
            </div>
            <div class="item">
              <span class="label">开课地点：</span>
              <span>
                {{
                  course.province_name +
                  course.city_name +
                  course.district_name +
                  course.address
                }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="coupon-service-wrap"
          v-if="
            (couponList.length > 0 && !isValid) ||
            (course.service && course.service.length > 0)
          "
        >
          <div class="coupon-wrap" v-if="couponList.length > 0 && !isValid">
            <span class="label">优惠券：</span>
            <Coupon @getCoupon="getCoupon" :couponList="couponList"></Coupon>
          </div>
          <CourseShowService :course="course"></CourseShowService>
        </div>
        <div
          class="placeholder"
          v-if="
            course.course_type != 7 &&
            couponList.length == 0 &&
            course.service.length == 0
          "
        ></div>
        <div class="footer clearfix" :class="{ free: course.is_free }">
          <CourseShowPrice :course="course"></CourseShowPrice>
          <CourseShowBuy
            :course="course"
            :has_buy="has_buy"
            @buy="buy"
            @goToStudy="goToStudy"
          ></CourseShowBuy>
        </div>
      </div>
      <a class="share" @click="onShareClick"></a>
    </div>
    <Lianbao
      :course="course"
      :discountList="discountList"
      :discountCourseList="discountCourseList"
      @discountBuy="val => $emit('discountBuy', val)"
      @changeDiscount="val => $emit('changeDiscount', val)"
    ></Lianbao>
    <CourseShowTabs
      :teachers="teachers"
      :course="course"
      :comments="comments"
      :recommendCourses="recommendCourses"
    ></CourseShowTabs>
  </div>
</template>
<script>
import Coupon from "../Coupon.vue";
import Lianbao from "./Lianbao.vue";
import CourseShowService from "./CourseShowService.vue";
import CourseShowValid from "./CourseShowValid.vue";
import CourseShowBuy from "./CourseShowBuy.vue";
import CourseShowPrice from "./CourseShowPrice.vue";
import CourseShowTabs from "./CourseShowTabs.vue";

export default {
  name: "RichCourseShow",
  components: {
    Coupon,
    Lianbao,
    CourseShowService,
    CourseShowValid,
    CourseShowBuy,
    CourseShowPrice,
    CourseShowTabs,
  },
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
    has_buy: {
      type: Boolean,
      default: false,
    },
    couponList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    teachers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    courses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    comments: {
      type: Array,
      default: () => {
        return [];
      },
    },
    recommendCourses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    discountList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    discountCourseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    course: function () {
      this.$nextTick(() => {
        this.removeImageTitle();
      });
    },
  },
  computed: {
    isValid() {
      return this.$services.CourseService.checkBuyValid(this.course);
    },
  },
  async mounted() {
    await this.$nextTick();
    this.removeImageTitle();
  },
  methods: {
    removeImageTitle() {
      let courseDetail = document.getElementById("course-detail");
      if (!courseDetail) {
        return;
      }
      courseDetail.querySelectorAll("img").forEach(ele => {
        ele.removeAttribute("title");
      });
    },
    onShareClick() {
      this.$emit("shareClick");
    },
    goToStudy() {
      this.$emit("goToStudy");
    },
    buy() {
      this.$emit("buy");
    },
    getCoupon(id) {
      this.$emit("getCoupon", id);
    },
    onCommentDelete() {
      this.$emit("commentDelete");
    },
  },
};
</script>
<style scoped lang="scss">
.cover-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  background-size: 1240px 369px;
  background-position: -20px -5px;
  padding: 24px 33px 0 30px;
  position: relative;
  margin-bottom: 20px;
  display: flex;

  .cover {
    margin: 0 36px 31px 0;
    flex-shrink: 0;
  }

  .right {
    position: relative;
    flex-grow: 1;
  }

  .title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(32, 36, 42, 1);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 14px;
  }

  .period {
    font-size: 14px;
    color: #999999;
    line-height: 1;
    display: flex;

    .ver-line {
      width: 1px;
      margin: 0 9px;
      background: #d9d9d9;
      display: inline-block;
    }
  }

  .share {
    width: 18px;
    height: 18px;
    position: absolute;
    background-image: url("~@/assets/images/course/share.png");
    background-size: 100% 100%;
    top: 28px;
    right: 23px;
    cursor: pointer;
    &:hover {
      background-image: url("~@/assets/images/course/share-hover.png");
    }
  }

  .apply {
    font-size: 14px;
    line-height: 1;
    display: flex;

    .left {
      width: 160px;
    }

    .item {
      margin-bottom: 20px;
    }

    .label {
      margin-right: 8px;
      color: #999999;
    }
  }

  .coupon-service-wrap {
    background: #fafafa;
    border-radius: 2px;
    padding: 17px 0 0 10px;
    margin: 0 0 24px -10px;
  }

  .coupon-wrap {
    display: flex;
    align-items: flex-start;

    .label {
      flex-shrink: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 22px;
    }

    /deep/ {
      .coupon-wrap {
        position: static;
      }
    }
  }

  .placeholder {
    height: 68px;
  }

  .footer {
    padding: 0 0 32px 0;
  }
}
</style>
